import { Flex } from '@chakra-ui/react';
import { ProgressCircleRing, ProgressCircleRoot } from '../ui/progress-circle';
export const CenteringLoadingCircle = () => {
  return (
    <Flex my={16} alignItems="center" justifyContent="center">
      <ProgressCircleRoot value={null} colorPalette="primary">
        <ProgressCircleRing />
      </ProgressCircleRoot>
    </Flex>
  );
};
